import _ from "lodash";
import React from "react";
import { UpdateCommand } from "../../../../../services/socket/NotificationInterface";
import { ColumnProperties } from "../BFTable";

type Props = {
  row: any;
  keyProp: string;
  conf: ColumnProperties;
  selected?: boolean;
  dirty?: UpdateCommand;
  params: any;
  data: any[];
};

const ComponentCellRenderer: React.FC<Props> = (props) => {
  const { row, keyProp, conf, selected, dirty, params, data } = props;

  const rowData = { ...row.original };
  return (window as any).ComponentsMapper.createElement(
    conf.component,
    {
      ...(params ? params : {}),
      row: rowData,
      selected: selected,
      dirty: dirty ? dirty.uType : false,
      dirtyObj: dirty,
      data,
    },
    keyProp
  );
};

// Use React.memo for optimization similar to shouldComponentUpdate
export default React.memo(ComponentCellRenderer, (prevProps, nextProps) => {
  return _.isEqual(nextProps, prevProps);
});
